/**
 * Tiny presentational atoms shared by the Cohorts tab components.
 */
import type { PairingDisplayStatus } from '@/lib/cohortEntity';

const PILL_STYLE: Record<PairingDisplayStatus, { bg: string; fg: string }> = {
  'Not started': { bg: 'var(--panel-3)', fg: 'var(--muted)' },
  'In progress': { bg: 'var(--good-soft)', fg: 'var(--good)' },
  Complete: { bg: 'var(--good-soft)', fg: 'var(--good)' },
  Cancelled: { bg: 'var(--warn-soft)', fg: 'var(--warn)' },
};

export function PairingStatusPill({ status }: { status: PairingDisplayStatus }) {
  const s = PILL_STYLE[status];
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: 10,
        background: s.bg,
        color: s.fg,
        fontSize: 11,
        fontWeight: 600,
      }}
    >
      {status}
    </span>
  );
}

export function Empty({ children }: { children: React.ReactNode }) {
  return (
    <div
      style={{
        padding: 24,
        textAlign: 'center',
        color: 'var(--muted)',
        fontSize: 12.5,
      }}
    >
      {children}
    </div>
  );
}
